"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterfaceTable = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var client_1 = require("@documentalist/client");
function InterfaceTable(attrs) {
    var api = attrs.api, data = attrs.data;
    var interfaceProps = data.docs.typescript[api].properties;
    return (0, mithril_1.default)(_1.Table, { class: 'Docs-interface-table' }, [
        (0, mithril_1.default)('tr', [
            (0, mithril_1.default)('th[style=max-width:175px; min-width: 175px]', 'Name'),
            (0, mithril_1.default)('th', 'Description')
        ]),
        interfaceProps.map(function (prop) { return renderPropRow(prop, data); })
    ]);
}
exports.InterfaceTable = InterfaceTable;
function renderPropRow(prop, data) {
    if (prop.documentation == null) {
        return;
    }
    var isRequired = prop.flags && !prop.flags.isOptional;
    return (0, mithril_1.default)('tr', [
        (0, mithril_1.default)('td', (0, mithril_1.default)('code', { class: isRequired ? 'is-required' : undefined }, prop.name)),
        (0, mithril_1.default)('td', [
            (0, mithril_1.default)('', renderPropType(prop, data)),
            mithril_1.default.trust(prop.documentation.contentsRaw)
        ])
    ]);
}
function renderPropType(prop, data) {
    var type = prop.type, defaultValue = prop.defaultValue;
    var typeDetails = data.docs.typescript[type];
    var isPopover = typeDetails && (typeDetails.kind === client_1.Kind.TypeAlias || typeDetails.kind === client_1.Kind.Enum);
    var trigger = (0, mithril_1.default)('.Docs-interface-type', { class: isPopover ? 'is-popover' : undefined }, [
        type,
        defaultValue && " = ".concat(defaultValue)
    ]);
    return isPopover
        ? (0, mithril_1.default)(_1.Popover, {
            class: 'Docs-interface-popover',
            content: [
                typeDetails.kind === client_1.Kind.Enum && typeDetails.members.map(function (member, index) { return [
                    (0, mithril_1.default)('span.Docs-interface-member', "".concat(member.defaultValue)),
                    (index !== typeDetails.members.length - 1) && (0, mithril_1.default)('span', '|')
                ]; }),
                typeDetails.kind === client_1.Kind.TypeAlias && typeDetails.type
            ],
            hasArrow: true,
            position: 'top',
            trigger: trigger
        })
        : trigger;
}
